import { Button } from 'antd';
import styled from 'styled-components';

export const ButtonStyle = styled(Button)`
  align-items: center;
  margin: 5px;
`;
